export function validatePhone (phone: string): boolean {
  const len = phone.replace(/\D/g,'').length;
  return ( len === 10 );
}